//Layouts
import LayoutAdmin from "../layouts/LayoutAdmin";
import { LayoutPublic } from "../layouts/LayoutPublic";
//Componentes públicos
import { HomePage } from "../pages/Public/Home/HomePage";
import HomePageAdmin from "../pages/Admin/Home/HomePageAdmin";
import { RegistroMainPage } from "../pages/Public/Aspirante";
import { EnviarCorreoPage } from "../pages/Public/EnviarPasswordAspirante/EnviarCorreoPage";
import { FormExito } from "../components/Public/CorreoPassword/FormExito";
import { UpdatePage } from "../pages/Public/UpdatePassword/UpdatePage";
import { ConsultadeVacantesPage } from "../pages/Public/ConsultaVacantes/ConsultaDeVacantesPage";
import { AvisoPrivacidadPage } from "../pages/Public/Home/AvisoPrivacidadPage";
import { CuentaDesactivadaPage } from "../pages/Public/CuentaSinAcceso/CuentaDesactivadaPage";

//Componentes privados
// import { DatosAspirantePage } from "../pages/Admin/Aspirante/DatosAspirantePage";
import { MiPerfilPage } from "../pages/Admin/Aspirante/MiPerfilMainPage";
import { ReqAcademicoPage } from "../pages/Admin/Aspirante/ReqAcademicoPage";
import { ExperienciaPage } from "../pages/Admin/Aspirante/ExperienciaPage";
import ExpedientePage from "../pages/Admin/Aspirante/ExpedientePage";
import { VacantesLoginPage } from "../pages/Admin/ConsultaVacantes/VacantesLoginPage";
import { AprobadaPage } from "../pages/Admin/ConsultaVacantes/AprobadaPage";
import { DeclinadaPage } from "../pages/Admin/ConsultaVacantes/DeclinadaPage";
import { PostulacionesPage } from "../pages/Admin/ConsultaVacantes/PostulacionesPage";

//others
import NotFound from "../components/General/NotFound";
import { linksRouter } from "./RouterLink";

/**
 * Se cargan las rutas y los componentes
 */
const routes = [
  {
    path: linksRouter.raizAdmin,
    component: LayoutAdmin,
    exact: false,
    routes: [
      {
        path: linksRouter.home,
        component: HomePageAdmin,
        exact: true,
      },
      {
        path: linksRouter.datosAspirante,
        component: MiPerfilPage,
        exact: true,
      },
      {
        path: linksRouter.formacionAcademica,
        component: ReqAcademicoPage,
        exact: true,
      },
      {
        path: linksRouter.experiencia,
        component: ExperienciaPage,
        exact: true,
      },
      {
        path: linksRouter.vacanteslogin,
        component: VacantesLoginPage,
        exact: true,
      },
      {
        path: linksRouter.aprobada,
        component: AprobadaPage,
        exact: true,
      },
      {
        path: linksRouter.declinada,
        component: DeclinadaPage,
        exact: true,
      },
      {
        path: linksRouter.postulaciones,
        component: PostulacionesPage,
        exact: true,
      },
      {
        path: linksRouter.updateAdmin,
        component: UpdatePage,
        exact: true,
      },
      {
        path: linksRouter.expediente,
        component: ExpedientePage,
        exact: true,
      },
      {
        path: linksRouter.avisoPrivacidadINEAdmin,
        component: AvisoPrivacidadPage,
        exact: true,
      },
      {
        path: linksRouter.avisoPrivacidadOPLEAdmin,
        component: AvisoPrivacidadPage,
        exact: true,
      },
      {
        component: NotFound,
      },
    ],
  },
  //El apartado público
  {
    path: linksRouter.raiz,
    component: LayoutPublic,
    exact: false,
    routes: [
      {
        path: linksRouter.raiz,
        component: HomePage,
        exact: true,
      },
      {
        path: linksRouter.registro,
        component: RegistroMainPage,
        exact: true,
      },
      {
        path: linksRouter.correo,
        component: EnviarCorreoPage,
        exact: true,
      },
      {
        path: linksRouter.FormExito,
        component: FormExito,
        exact: true,
      },
      // {
      //   path: linksRouter.update,
      //   component: UpdatePage,
      //   exact: true,
      // },
      {
        path: linksRouter.cvacantes,
        component: ConsultadeVacantesPage,
        exact: true,
      },
      {
        path: linksRouter.cuentaDesactivada,
        component: CuentaDesactivadaPage,
        exact: true,
      },
      {
        path: linksRouter.avisoPrivacidad,
        component: AvisoPrivacidadPage,
        exact: true,
      },

      {
        component: NotFound,
      },
    ],
  },
];

export default routes;
